/**
 * ai-tools.js - Chips Library Logic
 */

interface Prompt {
    id: string;
    title: string;
    content: string;
    category: string;
}

declare function showToast(msg: string): void;
declare function switchTab(tab: string): Promise<void>;
declare function autoExpand(textarea: HTMLTextAreaElement): void;

const mockPrompts: Prompt[] = [
    { id: '1', title: 'Viral Hook Generator', content: 'Generate 10 viral hooks for a video about...', category: 'Writing' },
    { id: '2', title: 'React Expert', content: 'Act as a senior React developer and review this...', category: 'Code' },
    { id: '3', title: 'Deep Researcher', content: 'Perform a comprehensive analysis on the topic of...', category: 'Research' }
];

function initLibrary() {
    const grid = document.getElementById('promptsGrid');
    if (!grid) return;

    // Keep the "New Clip" card and add mocks
    const newCard = grid.firstElementChild;
    grid.innerHTML = '';
    if (newCard) grid.appendChild(newCard);

    mockPrompts.forEach(p => {
        const card = document.createElement('div');
        card.style.cssText = `
            background: var(--bg-card);
            border: 1px solid var(--border);
            border-radius: 16px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            aspect-ratio: 1/1;
            cursor: pointer;
            transition: var(--transition);
        `;
        card.onclick = () => useLibraryPrompt(p);

        card.innerHTML = `
            <div>
                <div style="background: var(--primary-dim); color: var(--primary); padding: 4px 8px; border-radius: 8px; font-size: 0.7rem; font-weight: 600; display: inline-block; margin-bottom: 12px;">
                    ${p.category}
                </div>
                <h4 style="font-size: 0.95rem; font-weight: 700; line-height: 1.3;">${p.title}</h4>
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <button class="btn-ghost" style="padding: 4px;"><i class="fas fa-ellipsis-vertical"></i></button>
            </div>
        `;

        grid.appendChild(card);
    });
}

function useLibraryPrompt(p: Prompt) {
    showToast(`Using: ${p.title}`);
    (window as any).switchTab('helper');
    
    // We need to wait for helper to load before injecting text
    setTimeout(() => {
        if (typeof (window as any).setChatInput === 'function') {
            (window as any).setChatInput(p.content);
        } else {
            const input = document.getElementById('chatInput') as HTMLTextAreaElement;
            if (input) {
                input.value = p.content;
                (window as any).autoExpand?.(input);
            }
        }
    }, 100);
}

function createNewPrompt() {
    showToast('Create new prompt modal coming soon');
}

// Export to window
(window as any).initLibrary = initLibrary;
(window as any).useLibraryPrompt = useLibraryPrompt;
(window as any).createNewPrompt = createNewPrompt;
